import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.function.name.js";
import fetchAPI from 'utils/http/fetchAPI';
import handleError from 'utils/http/handleError';
import { SAMPLES_LOADED, SAMPLES_ERROR, SAMPLES_LOADING } from 'redux/actionTypes/samples';
import UploadStatus from 'utils/upload/UploadStatus';
var adaptedToRedux = function adaptedToRedux(samples, experimentId) {
  var reduxSamples = {};
  var buildReduxFiles = function buildReduxFiles(files) {
    var apiV1Files = {};
    Object.keys(files).forEach(function (key) {
      var _files$key;
      var fileType = (_files$key = files[key]) === null || _files$key === void 0 ? void 0 : _files$key.sampleFileType;
      if (!fileType) throw new Error('No sample file found');
      var status = files[key].uploadStatus === UploadStatus.UPLOADING ? UploadStatus.DROP_AGAIN : files[key].uploadStatus;
      apiV1Files[fileType] = {
        size: files[key].size,
        upload: {
          status: status
        }
      };
    });
    return apiV1Files;
  };
  samples.forEach(function (sample) {
    var reduxFiles = buildReduxFiles(sample.files);
    reduxSamples[sample.id] = {
      experimentId: experimentId,
      metadata: sample.metadata,
      createdDate: sample.createdAt,
      name: sample.name,
      lastModified: sample.updatedAt,
      files: reduxFiles,
      type: sample.sampleTechnology,
      options: sample.options,
      uuid: sample.id,
      kit: sample.kit
    };
  });
  return reduxSamples;
};
var loadSamples = function loadSamples(experimentId) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      var _url, _data, _samples, _errorMessage;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (experimentId) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              _context.prev = 2;
              dispatch({
                type: SAMPLES_LOADING
              });
              _url = "/v2/experiments/".concat(experimentId, "/samples");
              _context.next = 7;
              return fetchAPI(_url);
            case 7:
              _data = _context.sent;
              _samples = adaptedToRedux(_data, experimentId);
              dispatch({
                type: SAMPLES_LOADED,
                payload: {
                  samples: _samples
                }
              });
              _context.next = 16;
              break;
            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](2);
              // TODO we were not raising notifications here, validate whether raising or not now is ok
              _errorMessage = handleError(_context.t0);
              dispatch({
                type: SAMPLES_ERROR,
                payload: {
                  error: _errorMessage
                }
              });
            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 12]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
export default loadSamples;